export const META_PIXEL_ID = '1387566026669026'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { callMethod?: (...args: unknown[]) => void; queue?: unknown[] }
    _fbq?: unknown
  }
}

/**
 * Loads the Meta Pixel base code and fires the initial PageView.
 * Safe to call more than once: it bails out if the pixel is already present.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as NonNullable<Window['fbq']>

    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    window.fbq('init', META_PIXEL_ID)
  }

  window.fbq?.('track', 'PageView')
}

/** Fires a standard Meta Pixel event, e.g. trackPixelEvent('InitiateCheckout'). */
export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
